<template>
  <div class="pins-view">
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card class="pa-4 mb-4">
            <v-card-title class="text-h4 mb-4"> Gestión de PINs </v-card-title>
            <v-card-text
              >Puedes crear un PIN y compartirlo con tus estudiantes para iniciar
              prueba</v-card-text
            >

            <v-tabs v-model="activeTab" class="mb-4">
              <v-tab value="generate">
                <v-icon left>mdi-plus-circle</v-icon>
                Generar PIN
              </v-tab>
              <v-tab value="manage">
                <v-icon left>mdi-format-list-bulleted</v-icon>
                Gestionar PINs
              </v-tab>
            </v-tabs>

            <v-tabs-window v-model="activeTab">
              <v-tabs-window-item value="generate">
                <PinGeneration @pin-generated="handlePinGenerated" />
              </v-tabs-window-item>

              <v-tabs-window-item value="manage">
                <PinManagement @pin-deleted="handlePinDeleted" />
              </v-tabs-window-item>
            </v-tabs-window>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Success snackbar -->
    <v-snackbar v-model="showSuccessMessage" color="success" timeout="4000" location="top right">
      <v-icon left>mdi-check-circle</v-icon>
      {{ successMessage }}
    </v-snackbar>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import PinGeneration from '@/components/pins/PinGeneration.vue'
import PinManagement from '@/components/pins/PinManagement.vue'

const activeTab = ref('generate')
const showSuccessMessage = ref(false)
const successMessage = ref('')

const handlePinGenerated = (pin) => {
  successMessage.value = `PIN ${pin.code} generado exitosamente para ${pin.group_name}`
  showSuccessMessage.value = true

  // Switch to management tab to see the new PIN
  setTimeout(() => {
    activeTab.value = 'manage'
  }, 60000)
}

const handlePinDeleted = (pin) => {
  successMessage.value = `PIN ${pin.code} eliminado exitosamente`
  showSuccessMessage.value = true
}
</script>

<style scoped>
.pins-view {
  min-height: 100vh;
  background-color: #f5f5f5;
}
</style>
